/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SentEmail } from './SentEmail';
import {
    SentEmailFromJSON,
    SentEmailFromJSONTyped,
    SentEmailToJSON,
    SentEmailToJSONTyped,
} from './SentEmail';

/**
 * 
 * @export
 * @interface EmployeeMessageRecipient
 */
export interface EmployeeMessageRecipient {
    /**
     * 
     * @type {string}
     * @memberof EmployeeMessageRecipient
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeMessageRecipient
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeMessageRecipient
     */
    recipientId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeMessageRecipient
     */
    employeeMessageId: string;
    /**
     * 
     * @type {SentEmail}
     * @memberof EmployeeMessageRecipient
     */
    sentEmail: SentEmail | null;
}

/**
 * Check if a given object implements the EmployeeMessageRecipient interface.
 */
export function instanceOfEmployeeMessageRecipient(value: object): value is EmployeeMessageRecipient {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('recipientId' in value) || value['recipientId'] === undefined) return false;
    if (!('employeeMessageId' in value) || value['employeeMessageId'] === undefined) return false;
    if (!('sentEmail' in value) || value['sentEmail'] === undefined) return false;
    return true;
}

export function EmployeeMessageRecipientFromJSON(json: any): EmployeeMessageRecipient {
    return EmployeeMessageRecipientFromJSONTyped(json, false);
}

export function EmployeeMessageRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeMessageRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'recipientId': json['recipientId'],
        'employeeMessageId': json['employeeMessageId'],
        'sentEmail': SentEmailFromJSON(json['sentEmail']),
    };
}

  export function EmployeeMessageRecipientToJSON(json: any): EmployeeMessageRecipient {
      return EmployeeMessageRecipientToJSONTyped(json, false);
  }

  export function EmployeeMessageRecipientToJSONTyped(value?: EmployeeMessageRecipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'recipientId': value['recipientId'],
        'employeeMessageId': value['employeeMessageId'],
        'sentEmail': SentEmailToJSON(value['sentEmail']),
    };
}

